<template>
  <span v-if="!fieldValid">{{ $t('errors.NotAllowedWord', { f: $t(fieldName) }) }}</span>
</template>

<script>
export default {
  name: "ValidationNotAllowedWord",
  props: {
    fieldName: {required: true},
    fieldValid: {required: true}
  }
}
</script>

